import Vue from 'vue'
import Vuex from 'vuex'
import router from '../src/router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		accessToken: null,
		logginIn: false,
		loginError: null,
		useraccess: null,
		apiurl: 'https://backleasing.azurewebsites.net/',
		// apiurl: 'http://52.251.38.42/rhernandez/LEASING/apirestnc2026/',
		searchmenu: true,
		collapsemenu: false,
		filter: 'filter',
		accessRoles: [],
		accessPermisos: [],
		accessMenu: [],
		idUser: null,
		accessPaises: [],
		pais: null,
		disabledPais: false,
		indicadores: [],
		tiposMonedas: []
	},
	mutations: {
		loginStart: (state) => {
			state.loggingIn = true
		},
		loginStop: (state, errorMessage) => {
			state.loggingIn = false
			state.loginError = errorMessage
		},
		updatefilter: (state, filtro) => {
			state.filter = filtro
		},
		updatesearchmenu: (state, estado) => {
			state.searchmenu = estado
		},
		updatecollapsemenu: (state, estado) => {
			state.collapsemenu = estado
		},
		updateuseraccess: (state, username) => {
			state.useraccess = username
		},
		updateAccessToken: (state, accessToken) => {
			state.accessToken = accessToken
		},
		updateAccessRoles: (state, accessRoles) => {
			state.accessRoles = accessRoles
		},
		updateAccessPermisos: (state, accessPermisos) => {
			state.accessPermisos = accessPermisos
		},
		updateAccessMenu: (state, accessMenu) => {
			state.accessMenu = accessMenu
		},
		logout: (state) => {
			state.accessToken = null
			localStorage.removeItem('arrayNegocios')
			localStorage.removeItem('arrayPortafolio')
		},
		updateIdUsuario: (state, idUsuario) => {
			state.idUser = idUsuario
		},
		updateAccessPaises: (state, accessPaises) => {
			state.accessPaises = accessPaises
		},
		updatePais: (state, pais) => {
			state.pais = pais
		},
		setDisabledPais: (state, disabledPais) => {
			state.disabledPais = disabledPais
		},
		setIndicadores: (state, indicadores) => {
			state.indicadores = indicadores
		},
		setTiposMonedas: (state, tiposMonedas) => {
			state.tiposMonedas = tiposMonedas
		}
	},
	actions: {
		doLogin ({ commit }, token) {
			commit('loginStart')
			if (token === '0') {
			  localStorage.setItem('loginError', 0)
			  commit('loginStop', 'error token')
			  commit('updateAccessToken', null)
			  return false
			} else {
			  localStorage.setItem('accessToken', token)
			  commit('updateAccessToken', token)
			}
		},
		doUsername ({ commit }, username) {
			  localStorage.setItem('useraccess', username)
			  commit('updateuseraccess', username)
			  // router.push('/ResumenNegocio')
		},
		fetchAccessToken ({ commit }) {
			commit('updateAccessToken', localStorage.getItem('accessToken'))
			commit('updateuseraccess', localStorage.getItem('useraccess'))
			commit('updateIdUsuario', localStorage.getItem('IdUser'))
			commit('updateAccessPaises', JSON.parse(localStorage.getItem('accessPaises')))
			commit('updatePais', localStorage.getItem('pais') ? JSON.parse(localStorage.getItem('pais')) : null)
			commit('setDisabledPais', false)
		},
		fetchAccessMenu ({ commit }) {
			commit('updateAccessRoles', JSON.parse(localStorage.getItem('accessRoles')))
			commit('updateAccessPermisos', JSON.parse(localStorage.getItem('accessPermisos')))
			commit('updateAccessMenu', JSON.parse(localStorage.getItem('accessMenu')))
		},
		logout ({ commit }) {
			localStorage.removeItem('accessToken')
			localStorage.removeItem('IdUser')
			localStorage.removeItem('accessRoles')
			localStorage.removeItem('accessMenu')
			localStorage.removeItem('useraccess')
			localStorage.removeItem('accessPaises')
			localStorage.removeItem('pais')
			localStorage.removeItem('indicadores')
			localStorage.removeItem('disabledPais')
			commit('logout')
			router.push('/Login')
		},
		doSearchmenu ({ commit }, estado) {
			commit('updatesearchmenu', estado)
		},
		doCollapsemenu ({ commit }, estado) {
			commit('updatecollapsemenu', estado)
		},
		doFilter ({ commit }, filtro) {
			commit('updatefilter', filtro)
		},
		doMenu ({ commit }, menu) {
			localStorage.setItem('accessMenu', JSON.stringify(menu))
			commit('updateAccessMenu', menu)
		},
		doRoles ({ commit }, roles) {
			localStorage.setItem('accessRoles', JSON.stringify(roles))
			commit('updateAccessRoles', roles)
		},
		doPermisos ({ commit }, permisos) {
			localStorage.setItem('accessPermisos', JSON.stringify(permisos))
			commit('updateAccessPermisos', permisos)
		},
		doIdiUser ({ commit }, idUsuario) {
			localStorage.setItem('IdUser', idUsuario)
			commit('updateIdUsuario', idUsuario)
		},
		doIngresoNegocio ({ commit }, params) {
			var arrayNegocios = []
			if (localStorage.getItem('arrayNegocios')) {
				arrayNegocios = JSON.parse(localStorage.getItem('arrayNegocios'))
			}
			arrayNegocios.push(params)
			localStorage.setItem('arrayNegocios', JSON.stringify(arrayNegocios))
		},
		doPortafolio ({ commit }, params) {
			var arrayPortafolio = []
			if (localStorage.getItem('arrayPortafolio')) {
				arrayPortafolio = JSON.parse(localStorage.getItem('arrayPortafolio'))
			}
			arrayPortafolio.push(params)
			localStorage.setItem('arrayPortafolio', JSON.stringify(arrayPortafolio))
		},
		doIngresoCliente ({ commit }, params) {
			var arrayCliente = []
			if (localStorage.getItem('arrayCliente')) {
				arrayCliente = JSON.parse(localStorage.getItem('arrayCliente'))
			}
			arrayCliente.push(params)
			localStorage.setItem('arrayCliente', JSON.stringify(arrayCliente))
		},
		doPaises ({ commit }, paises) {
			localStorage.setItem('accessPaises', JSON.stringify(paises))
			commit('updateAccessPaises', paises)
		},
		doPais ({ commit }, pais) {
			localStorage.setItem('pais', JSON.stringify(pais))
			commit('updatePais', pais)
		},
		setDisabledPais: ({ commit }, disabledPais) => {
			localStorage.setItem('disabledPais', disabledPais)
			commit('setDisabledPais', disabledPais)
		},
		setIndicadores: ({ commit }, indicadores) => {
			localStorage.setItem('indicadores', JSON.stringify(indicadores))
			commit('setIndicadores', indicadores)
		},
		setTiposMonedas: ({ commit }, tiposMonedas) => {
			localStorage.setItem('tiposMonedas', JSON.stringify(tiposMonedas))
			commit('setTiposMonedas', tiposMonedas)
		}
	},
	getters: {}
})



// WEBPACK FOOTER //
// ./src/store.js